<div class="rightpart overview-r3-container">
	<div
		class="contentcards"
		*ngFor="let product of overviewStats"
		[ngClass]="{ 'map-v3-product-item': !product.isSelected, 'disable-button': product.isDisabled }"
		(click)="selectedProductDetails($event, product)"
	>
		<div *ngIf="product.productName.toLowerCase() !== 'email'" class="displayCards {{ product.sectionClass }}">
			<p class="text header-font">
				<img
					src="../../../../../assets/images/active.png"
					*ngIf="product.isSelected"
					width="20"
					style="vertical-align: middle; margin-right: 7px"
				/>
				<img
					src="../../../../../assets/images/inactive.png"
					*ngIf="!product.isSelected"
					width="20"
					style="vertical-align: middle; margin-right: 7px"
				/>
				{{ product.productName }}
			</p>
			<div
				class="contentDisplay {{ product.productName }}"
				*ngIf="
					!['Display', 'GeoFence', 'GeoVideo', 'Geofence', 'Geovideo', 'CTV / OTT', 'Streaming Audio'].includes(
						product.productName
					) && !youtubeViewsPermission
				"
			>
				<div class="Impression defaultimpression">
					<div class="header-font" *ngIf="product.impressions">
						{{ product.impressions | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.impressions">--</div>
					<div class="displayText">Impressions</div>
				</div>
				<div class="clicksext">
					<div class="header-font" *ngIf="product.clicks">
						{{ product.clicks | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.clicks">--</div>
					<div class="displayText">Clicks</div>
				</div>
				<div class="ctr">
					<div
						class="header-font"
						*ngIf="
							product.impressions === null ||
								product.impressions === 0 ||
								product.clicks === 0 ||
								product.clicks === null ||
								product.ctr === null;
							else elseblock
						"
					>
						--
					</div>
					<ng-template #elseblock>
						<div class="header-font" *ngIf="product.ctr >= 0">{{ product.ctr }}%</div>
					</ng-template>

					<div class="displayText">CTR</div>
				</div>
			</div>

			<div
				class="contentDisplay {{ product.productName }} youtubeViews"
				*ngIf="
					!['Display', 'GeoFence', 'GeoVideo', 'Geofence', 'Geovideo', 'CTV / OTT', 'Streaming Audio'].includes(
						product.productName
					) && youtubeViewsPermission
				"
			>
				<div class="Impression defaultimpression">
					<div class="header-font" *ngIf="product.impressions">
						{{ product.impressions | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.impressions">--</div>
					<div class="displayText">Impressions</div>
				</div>
				<div class="clicksext">
					<div class="header-font" *ngIf="product.clicks">
						{{ product.clicks | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.clicks">--</div>
					<div class="displayText">Clicks</div>
				</div>
				<div class="ctr">
					<div
						class="header-font"
						*ngIf="
							product.impressions === null ||
								product.impressions === 0 ||
								product.clicks === 0 ||
								product.clicks === null ||
								product.ctr === null;
							else elseblock
						"
					>
						--
					</div>
					<ng-template #elseblock>
						<div class="header-font" *ngIf="product.ctr >= 0">{{ product.ctr }}%</div>
					</ng-template>

					<div class="displayText">CTR</div>
				</div>
				<div class="youtube-views" *ngIf="['Pre Roll'].includes(product.productName) && youtubeViewsPermission">
					<div class="header-font" *ngIf="product.youtube_verified_imprs">
						{{ product.youtube_verified_imprs | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.youtube_verified_imprs">--</div>
					<div class="displayText">YOUTUBE VIEWS</div>
				</div>
			</div>

			<div class="contentDisplay" *ngIf="['Display'].includes(product.productName) && isMarketronPartner">
				<div class="Impression defaultimpression">
					<div class="header-font" *ngIf="product.impressions">
						{{ product.impressions | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.impressions">--</div>
					<div class="displayText">Impressions</div>
				</div>
				<div class="clicksext">
					<div class="header-font" *ngIf="product.clicks">
						{{ product.clicks | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.clicks">--</div>
					<div class="displayText">Clicks</div>
				</div>
				<div class="ctr">
					<div
						class="header-font"
						*ngIf="
							product.impressions === null ||
								product.impressions === 0 ||
								product.clicks === 0 ||
								product.clicks === null ||
								product.ctr === null;
							else elseblock
						"
					>
						--
					</div>
					<ng-template #elseblock>
						<div class="header-font" *ngIf="product.ctr >= 0">{{ product.ctr }}%</div>
					</ng-template>

					<div class="displayText">CTR</div>
				</div>
			</div>
			<div class="contentDisplay" *ngIf="['Display'].includes(product.productName) && !isMarketronPartner">
				<div class="Impression defaultimpression">
					<div class="header-font" *ngIf="product.impressions">
						{{ product.impressions | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.impressions">--</div>
					<div class="displayText">Impressions</div>
				</div>
				<div class="clicksext">
					<div class="header-font" *ngIf="product.clicks">
						{{ product.clicks | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.clicks">--</div>
					<div class="displayText">Clicks</div>
				</div>
				<div class="ctr">
					<div
						class="header-font"
						*ngIf="
							product.impressions === null ||
								product.impressions === 0 ||
								product.clicks === 0 ||
								product.clicks === null ||
								product.ctr === null;
							else elseblock
						"
					>
						--
					</div>
					<ng-template #elseblock>
						<div class="header-font" *ngIf="product.ctr >= 0">{{ product.ctr }}%</div>
					</ng-template>

					<div class="displayText">CTR</div>
				</div>
			</div>

			<div
				class="contentDisplay"
				*ngIf="['GeoFence', 'GeoVideo', 'Geofence', 'Geovideo'].includes(product.productName) && !offlineDataAccess"
			>
				<div class="Impression defaultimpression">
					<div class="header-font" *ngIf="product.impressions">
						{{ product.impressions | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.impressions">--</div>
					<div class="displayText">Impressions</div>
				</div>
				<div class="clicksext">
					<div class="header-font" *ngIf="product.clicks">
						{{ product.clicks | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.clicks">--</div>
					<div class="displayText">Clicks</div>
				</div>
				<div class="ctr">
					<div
						class="header-font"
						*ngIf="
							product.impressions === null ||
								product.impressions === 0 ||
								product.clicks === 0 ||
								product.clicks === null ||
								product.ctr === null;
							else elseblock
						"
					>
						--
					</div>
					<ng-template #elseblock>
						<div class="header-font" *ngIf="product.ctr >= 0">{{ product.ctr }}%</div>
					</ng-template>

					<div class="displayText">CTR</div>
				</div>
			</div>
			<div
				class="contentDisplay"
				*ngIf="['GeoFence', 'GeoVideo', 'Geofence', 'Geovideo'].includes(product.productName) && offlineDataAccess"
			>
				<div class="Impression offlineimpression">
					<div class="header-font" *ngIf="product.impressions">
						{{ product.impressions | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.impressions">--</div>
					<div class="displayText">Impressions</div>
				</div>
				<div class="clicksext offlineclicks">
					<div class="header-font" *ngIf="product.clicks">
						{{ product.clicks | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.clicks">--</div>
					<div class="displayText">Clicks</div>
				</div>
				<div class="ctr">
					<div
						class="header-font"
						*ngIf="
							product.impressions === null ||
								product.impressions === 0 ||
								product.clicks === 0 ||
								product.clicks === null ||
								product.ctr === null;
							else elseblock
						"
					>
						--
					</div>
					<ng-template #elseblock>
						<div class="header-font" *ngIf="product.ctr >= 0">{{ product.ctr }}%</div>
					</ng-template>

					<div class="displayText">CTR</div>
				</div>
				<div class="offlineVisits" *ngIf="offlineDataAccess">
					<div class="header-font" *ngIf="product.offline_visits">
						{{ product.offline_visits | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.offline_visits">--</div>
					<div class="displayText">Offline Visits</div>
				</div>
			</div>
			<div class="contentDisplay" *ngIf="['CTV / OTT', 'Streaming Audio'].includes(product.productName)">
				<div class="Impression defaultimpression">
					<div class="header-font" *ngIf="product.impressions">
						{{ product.impressions | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.impressions">--</div>
					<div class="displayText">Impressions</div>
				</div>
				<div class="clicksext">
					<div class="header-font" *ngIf="product.completions">
						{{ product.completions | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.completions">--</div>
					<div class="displayText">Completions</div>
				</div>
				<div class="ctr">
					<div class="header-font" *ngIf="product.completions_rate">{{ product.completions_rate }}%</div>
					<div class="header-font" *ngIf="!product.completions_rate">--</div>
					<div class="displayText">
						<span *ngIf="product.productName === 'Streaming Audio'">ACR</span>
						<span *ngIf="product.productName === 'CTV / OTT'">VCR</span>
					</div>
				</div>
			</div>
		</div>
		<div
			*ngIf="product.productName.toLowerCase() == 'email'"
			class="displayCards {{ product.sectionClass }} email-card"
		>
			<p class="text header-font">
				<img
					src="../../../../../assets/images/active.png"
					*ngIf="product.isSelected"
					width="20"
					style="vertical-align: middle; margin-right: 7px"
				/>
				<img
					src="../../../../../assets/images/inactive.png"
					*ngIf="!product.isSelected"
					width="20"
					style="vertical-align: middle; margin-right: 7px"
				/>
				{{ product.productName }}
			</p>
			<div class="contentDisplay email-specific">
				<div class="Impression defaultimpression">
					<div class="header-font" *ngIf="product.audience">
						{{ product.audience | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.audience">--</div>
					<span
						class="displayText"
						appTooltip
						title="Number of emails sent"
						data-size="small"
						[options]="tooltipOptions"
						>Sends</span
					>
				</div>
				<div class="clicksext">
					<div class="header-font" *ngIf="product.opens">
						{{ product.opens | formatNumber }}
					</div>
					<div class="header-font" *ngIf="!product.opens">--</div>
					<span
						class="displayText"
						appTooltip
						title="Number of emails opened <br><br> Open Rate = Opens/Sends"
						data-size="small"
						[options]="tooltipOptions"
						>Opens</span
					>
				</div>
				<div class="ctr">
					<div class="header-font" *ngIf="product.clicks">{{ product.clicks | formatNumber }}</div>
					<div class="header-font" *ngIf="!product.clicks">--</div>
					<div class="displayText">
						<span
							appTooltip
							title="Number of clicks within an email <br><br> Click Rate = Clicks/Sends"
							data-size="small"
							[options]="tooltipOptions"
							>Clicks</span
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
